import styles from './WorkflowCard.module.scss';
import { Typography, Dropdown, Button, Rate } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import editImg from '@/assets/images/common/edit.png';
import deleteImg from '@/assets/images/common/delete.png';
import React from "react";
import { useT } from '@/common/utils/translation';
import useIsMobile from "@/common/hooks/useIsMobile.js";
import CoverImage from "@/pages/components/CoverImage";

const { Paragraph, Text } = Typography;

function WorkflowCard({
  cardInfo = {},
  editAble,
  editDelete,
  className,
  onClick,
  onEdit,
  style,
  sortHandRender,
  detailButtonRef,
  detailActionLabel
}) {
  const [isMobile] = useIsMobile();
  let t = useT();

  const items = [
    {
      label: <Text
        type="link"
        style={{display: 'flex', alignItems: 'center'}}
        onClick={(event) => {
          event.stopPropagation();
          onEdit?.('edit');
        }}
      >
        <img src={editImg} style={{height: '16px', width: '16px', marginRight: '8px'}}/>
        {t('createCenter_edit_application')}
      </Text>,
      key: '0',
    },
    {
      label: <Text
        type="danger"
        style={{display: 'flex', alignItems: 'center'}}
        onClick={(event) => {
          event.stopPropagation();
          onEdit?.('delete');
        }}
      >
        <img src={deleteImg} style={{height: '16px', width: '16px', marginRight: '8px'}}/>
        {t('createCenter_delete_delete')}
      </Text>,
      key: '1',
    },
  ];

  return (
    <div
      className={`${styles.container} ${className} ${onClick ? styles.hoverStyle : ''}`}
      style={{cursor: onClick ? 'pointer' : '', ...style}}
      onClick={() => {
        onClick?.();
      }}
    >
      <div className={styles.dragHand}>
        {sortHandRender}
      </div>
      
      {/* 大封面图 */}
      <div className={styles.coverContainer}>
        <CoverImage 
          coverImage={cardInfo.coverImage}
          width="100%"
          height="100%" // 改为100%，完全填充容器
          style={{ 
            objectFit: 'cover',
            width: '100%',
            height: '100%',
            borderRadius: '8px 8px 0 0'
          }} // 确保封面完全显示
        />
        
        {/* 评分显示在封面右下角 */}
        {cardInfo.points && (
          <div className={styles.coverRating}>
            <Rate disabled defaultValue={cardInfo.points} size="small" />
          </div>
        )}
      </div>

      {/* 标题和详情 */}
      <div className={styles.content}>
        <div className={styles.titleSection}>
          <Paragraph ellipsis={{rows: 1}} className={styles.cardTitle}>
            {detailButtonRef ? <button type="button" ref={detailButtonRef} className="maintenance-detail-trigger" data-detail-trigger={`application-workflow:${cardInfo.id ?? cardInfo.appId}`}
              aria-label={`${detailActionLabel}: ${cardInfo.titleCn || cardInfo.name}`} onClick={event => { event.stopPropagation(); onClick?.(); }}>{cardInfo.titleCn || cardInfo.name}</button> : cardInfo.titleCn || cardInfo.name}
          </Paragraph>
        </div>

        <Paragraph ellipsis={{rows: 2}} className={styles.cardDescription}>
          {cardInfo.detailCn || cardInfo.detail || cardInfo.description}
        </Paragraph>

        {/* 底部只保留创建者信息 */}
        <div className={styles.footer}>
          <div className={styles.meta}>
            <div className={styles.createBy}>
              {cardInfo.createBy}
            </div>
          </div>
        </div>
      </div>
      
      {/* 删除按钮在卡片右下角 */}
      {(editAble || editDelete) && (
        <div className={styles.cardEditButton} onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}>
          <Dropdown menu={{
            items: items.filter(item => {
              return editDelete ? item.key === '1' : true;
            })
          }}>
            <span className={styles.editButton}>
              <MoreOutlined style={{fontSize: '14px', transform: 'rotate(90deg)'}}/>
            </span>
          </Dropdown>
        </div>
      )}
    </div>
  );
}

export default WorkflowCard;
